import React, { Component, Fragment } from 'react'
import { Menu, Divider } from 'antd'
import { autoGenKey } from '../../../lib/helper'
const { SubMenu } = Menu

const checkMenuVisibility = (list, permissions) => {
  //   console.log('list permissions', permissions)
  //   console.log('list ', list)
  if (
    typeof permissions == 'undefined' ||
    typeof permissions == 'string' ||
    permissions == []
  )
    return true

  let hideMenu = true
  for (let i = 0; i < list.length; i++) {
    let menu = list[i]

    let canAccess = permissions.find((ele) => {
      return ele.matching_name == menu && ele.can_view == 1
    })

    if (typeof canAccess != 'undefined') {
      hideMenu = false
    }
  }

  return hideMenu
}

const keepArray = []

export class AutorizeMenu extends Component {
  render() {
    let { permissions, children } = this.props
    // console.log('childrenchildren', children)
    let haveChild = false
    let isSubmenu = false

    if (typeof children.length == 'number') {
      children.forEach((ele) => {
        if (typeof ele.props.children.length == 'number') haveChild = true
      })
    } else {
      if (typeof children.props.children.length == 'number') haveChild = true
      if (
        typeof children.type.isMenuItem != 'undefined' &&
        children.type.isMenuItem
      )
        isSubmenu = true
      children = [children]
    }

    if (!haveChild && !isSubmenu) {
      return (
        <Menu
          mode='inline'
          onClick={({ item, key, keyPath, selectedKeys, domEvent }) => {
            // `active_key` = ตัวตนสำหรับ **ไฮไลต์** ซึ่งอาจไม่เท่ากับ `matching_name`
            // (ตัวตนสำหรับ **สิทธิ์**) เช่นเมนูที่ยังไม่มีแถวของตัวเองใน m_permission
            // ต้องยืม matching_name ของเมนูอื่นไปก่อน — ไม่งั้นกดแล้วไปไฮไลต์เมนูที่ยืมมา
            // ไม่มี active_key = พฤติกรรมเดิมทุกประการ
            this.props.handleActiveMenu(
              item.props.active_key || item.props.matching_name
            )
          }}
          openKeys={this.props.openKeysMenu}
          onOpenChange={this.props.handleonOpenChange}
        >
          <SubMenu
            className='ant-menu-submenu-focus'
            popupClassName='popup-menu-custom scroll-style'
            style={{
              display:
                checkMenuVisibility(
                  //   children.map(ele => ele.props.matching_name),

                  children.map((ele) => {
                    if (
                      ele.props.web_use != 'undefined' &&
                      ele.props.web_use != '' &&
                      ele.props.web_use == ele.props.web_endpoint
                    ) {
                      return ele.props.matching_name
                    } else if (
                      ele.props.web_use != 'undefined' &&
                      ele.props.web_use == ''
                    ) {
                      return ele.props.matching_name
                    } else {
                      return ''
                    }
                  }),
                  permissions
                ) && 'none',
            }}
            key={this.props.subkey}
            title={this.props.title}
          >
            {children.filter((ele) => {
              let menu = ele.props.matching_name
              let canAccess = null
              if (
                ele.props.web_use != 'undefined' &&
                ele.props.web_use != '' &&
                ele.props.web_use == ele.props.web_endpoint
              ) {
                canAccess = permissions.find((ele) => {
                  return ele.matching_name == menu && ele.can_view == 1
                })
              } else if (
                ele.props.web_use != 'undefined' &&
                ele.props.web_use == ''
              ) {
                canAccess = permissions.find((ele) => {
                  return ele.matching_name == menu && ele.can_view == 1
                })
              }
              return canAccess
            })}

            {/* external link */}
            {this.props.createExternalMenu(
              permissions,
              this.props.menu_hierarchy || ''
            )}
          </SubMenu>
        </Menu>
      )
    } else {
      let resultArr = []
      children.forEach((ele) => {
        if (typeof ele.props.children.length == 'number') {
          let result = ele.props.children.map((ele1) => {
            if (
              ele1.props.web_use != 'undefined' &&
              ele1.props.web_use != '' &&
              ele1.props.web_use == ele1.props.web_endpoint
            ) {
              return ele1.props.matching_name
            } else if (
              ele1.props.web_use != 'undefined' &&
              ele1.props.web_use == ''
            ) {
              return ele1.props.matching_name
            }
          })
          result.map((ele) => {
            if (typeof ele != 'undefined') {
              resultArr.push(ele)
            }
          })
        } else {
          if (
            typeof ele.props.children.type.isMenuItem != 'undefined' &&
            ele.props.children.type.isMenuItem
          ) {
            if (
              typeof ele.props.children.props.web_use != 'undefined' &&
              ele.props.children.props.web_use != '' &&
              ele.props.children.props.web_use ==
                ele.props.children.props.web_endpoint
            ) {
            } else if (
              typeof ele.props.children.props.web_use != 'undefined' &&
              ele.props.children.props.web_use == ''
            ) {
              resultArr.push(ele.props.children.props.matching_name)
            }
          } else {
            if (
              typeof ele.props.web_use != 'undefined' &&
              ele.props.web_use != '' &&
              ele.props.web_use == ele.props.web_endpoint
            ) {
              resultArr.push(ele.props.matching_name)
            } else if (
              typeof ele.props.web_use != 'undefined' &&
              ele.props.web_use == ''
            ) {
              resultArr.push(ele.props.matching_name)
            }
          }
        }
      })

      // Helper function ตรวจสอบว่า item มี permission หรือไม่
      const checkItemPermission = (item) => {
        let find = permissions.find(
          (p) => p.matching_name == item.props.matching_name && p.can_view == 1
        )
        if (typeof find != 'undefined') {
          if (
            typeof item.props.web_use != 'undefined' &&
            item.props.web_use != '' &&
            item.props.web_use == item.props.web_endpoint
          ) {
            return true
          } else if (
            typeof item.props.web_use != 'undefined' &&
            item.props.web_use == ''
          ) {
            return true
          }
        }
        return false
      }

      // Helper function ตรวจสอบว่า SubMenu มี children ที่มี permission หรือไม่ (recursive)
      const hasPermittedChildren = (element) => {
        let children = element.props.children
        if (typeof children.length != 'number') {
          children = [children]
        }

        for (let child of children) {
          // ถ้าเป็น SubMenu ให้ตรวจสอบ children ของมัน
          if (typeof child.type.isSubMenu != 'undefined' && child.type.isSubMenu) {
            if (hasPermittedChildren(child)) return true
          }
          // ถ้าเป็น MenuItem ให้ตรวจสอบ permission
          else if (checkItemPermission(child)) {
            return true
          }
        }
        return false
      }

      // Helper function filter children ของ SubMenu (recursive)
      const filterChildren = (element) => {
        let children = element.props.children
        if (typeof children.length != 'number') {
          children = [children]
        }

        let filtered = children.filter((child) => {
          // ถ้าเป็น SubMenu ให้ตรวจสอบว่ามี children ที่มี permission หรือไม่
          if (typeof child.type.isSubMenu != 'undefined' && child.type.isSubMenu) {
            return hasPermittedChildren(child)
          }
          // ถ้าเป็น MenuItem ให้ตรวจสอบ permission
          return checkItemPermission(child)
        })

        // filter children ของ nested SubMenu ด้วย
        filtered = filtered.map((child) => {
          if (typeof child.type.isSubMenu != 'undefined' && child.type.isSubMenu) {
            return {
              ...child,
              props: {
                ...child.props,
                children: filterChildren(child),
              },
            }
          }
          return child
        })

        return filtered
      }

      let resultChildren = children.filter((ele) => {
        // ถ้าเป็น SubMenu ให้ตรวจสอบว่ามี children ที่มี permission หรือไม่
        if (typeof ele.type.isSubMenu != 'undefined' && ele.type.isSubMenu) {
          return hasPermittedChildren(ele)
        }

        let subChildren = ele.props.children
        if (typeof subChildren.length != 'number') {
          if (
            typeof ele.props.children.type.isMenuItem != 'undefined' &&
            ele.props.children.type.isMenuItem
          ) {
            subChildren = [subChildren]
          } else {
            subChildren = [ele]
          }
        }
        let res = false

        subChildren.forEach((ele1) => {
          let canAccess = false

          permissions.forEach((ele2) => {
            if (
              ele2.matching_name == ele1.props.matching_name &&
              ele2.can_view == 1
            ) {
              if (
                typeof ele1.props.web_use != 'undefined' &&
                ele1.props.web_use != '' &&
                ele1.props.web_use == ele1.props.web_endpoint
              ) {
                canAccess = true
                return
              } else if (
                typeof ele1.props.web_use != 'undefined' &&
                ele1.props.web_use == ''
              ) {
                canAccess = true
                return
              } else {
                canAccess = false
                return
              }
            }
          })

          if (canAccess) {
            res = true
            return
          }
        })

        return res
      })

      resultChildren = resultChildren.map((ele) => {
        // ถ้าเป็น SubMenu ให้ filter children แบบ recursive
        if (typeof ele.type.isSubMenu != 'undefined' && ele.type.isSubMenu) {
          return {
            ...ele,
            props: {
              ...ele.props,
              children: filterChildren(ele),
            },
          }
        }

        let subChildren = ele.props.children
        if (typeof subChildren.length != 'number') {
          if (typeof ele.type.isSubMenu != 'undefined' && ele.type.isSubMenu) {
            subChildren = [subChildren]
          } else if (
            typeof ele.type.isMenuItem != 'undefined' &&
            ele.type.isMenuItem
          ) {
            subChildren = [ele]
          }
        }

        subChildren = subChildren.filter((ele1) => {
          let find = permissions.find(
            (ele2) =>
              ele2.matching_name == ele1.props.matching_name &&
              ele2.can_view == 1
          )

          if (typeof find != 'undefined') {
            if (
              typeof ele1.props.web_use != 'undefined' &&
              ele1.props.web_use != '' &&
              ele1.props.web_use == ele1.props.web_endpoint
            ) {
              return true
            } else if (
              typeof ele1.props.web_use != 'undefined' &&
              ele1.props.web_use == ''
            ) {
              return true
            } else {
              return false
            }
          }
          return false
        })

        return {
          ...ele,
          props: {
            ...ele.props,
            children: subChildren,
          },
        }
      })

      return (
        <Menu
          mode='inline'
          onClick={({ item, key, keyPath, selectedKeys, domEvent }) => {
            // `active_key` = ตัวตนสำหรับ **ไฮไลต์** ซึ่งอาจไม่เท่ากับ `matching_name`
            // (ตัวตนสำหรับ **สิทธิ์**) เช่นเมนูที่ยังไม่มีแถวของตัวเองใน m_permission
            // ต้องยืม matching_name ของเมนูอื่นไปก่อน — ไม่งั้นกดแล้วไปไฮไลต์เมนูที่ยืมมา
            // ไม่มี active_key = พฤติกรรมเดิมทุกประการ
            this.props.handleActiveMenu(
              item.props.active_key || item.props.matching_name
            )
          }}
          openKeys={this.props.openKeysMenu}
          onOpenChange={this.props.handleonOpenChange}
        >
          <SubMenu
            popupClassName='popup-menu-custom-set-width'
            style={{
              display: checkMenuVisibility(resultArr, permissions) && 'none',
            }}
            key={this.props.subkey}
            title={this.props.title}
          >
            {resultChildren.map((ele) => {
              if (
                typeof ele.type.isSubMenu != 'undefined' &&
                ele.type.isSubMenu
              ) {
                // ใน submenu ให้ต่อท้ายด้วย menuItem ของ externalMenu
                return (
                  <SubMenu
                    key={ele.props.matching_name || ele.key}
                    title={ele.props.title}
                    popupClassName='popup-menu-custom scroll-style'
                  >
                    {ele.props.children.map((subEle) => {
                      if (
                        typeof subEle.type.isSubMenu != 'undefined' &&
                        subEle.type.isSubMenu
                      ) {
                        // รองรับ nested SubMenu ระดับที่ 3
                        return (
                          <SubMenu
                            key={subEle.props.matching_name || subEle.key}
                            title={subEle.props.title}
                            popupClassName='popup-menu-custom scroll-style'
                          >
                            {subEle.props.children.map((innerEle) => {
                              if (
                                typeof innerEle.type.isMenuItem != 'undefined' &&
                                innerEle.type.isMenuItem
                              ) {
                                return innerEle
                              } else {
                                return innerEle.props.children
                              }
                            })}
                            {this.props.createExternalMenu(
                              permissions,
                              subEle.props.menu_hierarchy || ''
                            )}
                          </SubMenu>
                        )
                      } else if (
                        typeof subEle.type.isMenuItem != 'undefined' &&
                        subEle.type.isMenuItem
                      ) {
                        return subEle
                      } else {
                        return subEle.props.children
                      }
                    })}

                    {/* ให้ต่อท้ายด้วย menuItem ของ externalMenu */}
                    {this.props.createExternalMenu(
                      permissions,
                      ele.props.menu_hierarchy || ''
                    )}
                  </SubMenu>
                )
              } else if (
                typeof ele.type.isMenuItem != 'undefined' &&
                ele.type.isMenuItem
              ) {
                return ele.props.children
              }
            })}

            {/* ให้ต่อท้ายด้วย menuItem ของ externalMenu */}
            {this.props.createExternalMenu(
              permissions,
              this.props.menu_hierarchy || ''
            )}
          </SubMenu>
        </Menu>
      )
    }
  }
}

export default { AutorizeMenu }
